import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const InterviewerReport = () => {

  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");


  const [searchTerm, setSearchTerm] = useState("");
  const [interviwerReport, setInterviewerReport] = useState([]);
  const [interviewerList, setInterviewerList] = useState([]);
  const [hrNameList, setHRNameList] = useState([]);
  const [respStatus, setRepStatus] = useState(0);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [filterFormData, setFilterData] = useState([
    // { label: "HR Name", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  const columns = {
    InterviewerName: { text: "Interviewer", visible: true },
    HRName: { text: "HR Name", visible: true },
    RescheduleRequested: { text: "Reschedule Requested", align: "center", visible: true },
    SelectedForNextRound: { text: "Selected For Next Round", align: "center", visible: true },
    FinalSelected: { text: "Final Selected", align: "center", visible: true },
    Rejected: { text: "Rejected", align: "center", visible: true },
    TotalInterview: { text: "Total Interview", align: "center", visible: true }
  };
  const defaultColumns = {
    InterviewerName: true,
    HRName: true,
    RescheduleRequested: true,
    SelectedForNextRound: true,
    FinalSelected: true,
    Rejected: true
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Interviewer Report"))
  }, [])
  const formDatas = [
    { name: "Interviewer Name", type: "Select", options: [...interviewerList] },
    { name: "HR Name", type: "Select", options: [...hrNameList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchInterviewerReport = async () => {
    SetApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/6?P_ID&P_HR&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}`
      );
      SetApiStatus(response?.status);
      const data = response?.data?.data?.header;
      setInterviewerReport(data);

      // Interviewer Name List
      const IntervieweList = response?.data?.data?.interviwerName.map((tech) => ({
        value: tech.VALUE,
        label: tech.TEXT,
      }));
      setInterviewerList(IntervieweList);

      // Hr Name List
      const hrList = response?.data?.data?.hrname.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setHRNameList(hrList);
    } catch (error) {
      SetApiStatus(500);
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchInterviewerReport();
  }, []);

  const handleGetData = async() => {
      SetApiStatus(undefined);
      try {
      const response = await GetServiceCaller(
        `${API_URL}report/6?P_ID=${filterFormData.find((o) => o.label === "Interviewer Name")
          ? filterFormData.find((o) => o.label === "Interviewer Name").value
          : 0
        }&P_HR=${filterFormData.find((o) => o.label === "HR Name")
          ? filterFormData.find((o) => o.label === "HR Name").value
          : 0
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }`
      );
      SetApiStatus(response?.status);
      const data = response?.data?.data?.header;
      setInterviewerReport(data);

      // Interviewer Name List
      const IntervieweList = response?.data?.data?.interviwerName.map((tech) => ({
        value: tech.VALUE,
        label: tech.TEXT,
      }));
      setInterviewerList(IntervieweList);

      // Hr Name List
      const hrList = response?.data?.data?.hrname.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setHRNameList(hrList);
    } catch (error) {
      SetApiStatus(500);
      console.error("Error fetching skills:", error);
    }
  };


  const handleReset = async () => {
    SetApiStatus(undefined);
    setFilterData([
      { label: "HR Name", value: "" },
      { label: "Interviewer Name", value: "" },
      { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    ]);
    await fetchInterviewerReport();
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={interviwerReport}
              columns={columns}
              // defaultColumns={defaultColumns}
              // itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isSorting={true}
              handleReset={handleReset}
              isFilterRequired={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default InterviewerReport;
